export default "Bureaux fermés le week-end, CVC saisonnier : vos puissances souscrites sont-elles surdimensionnées ? Audit TURPE immeuble par immeuble, économies récurrentes sans changer de fournisseur.";
